export const endpoint = ({
    detailmovies: 'https://yts.mx/api/v2/movie_details.json?movie_id=',
    searchmovies: 'https://yts.mx/api/v2/list_movies.json?&query_term=',
    genremovies: 'https://yts.mx/api/v2/list_movies.json?limit=24&query_term=2021&genre=',
    catagories: 'https://yts.mx/api/v2/list_movies.json?query_term=2022',
    trendingmovies:'https://yts.mx/api/v2/list_movies.json?trending-movies',
    similarmovies:'https://yts.mx/api/v2/movie_suggestions.json?movie_id=',
    browsermovies:'https://yts.mx/api/v2/list_movies.json?'
})